__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-event-specs/v5_1_2/";